export const LAST_UPDATED = '2022-05-01';
